module.exports = __webpack_public_path__ + "pinkc.bcb92f6b.png";